import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import * as S from "./styles";

const BENEFITS = [
  "Atenda no WhatsApp 24h por dia, sem contratar mais ninguém",
  "Triagem e qualificação automática dos leads que chegam",
  "IA treinada para o contexto jurídico do seu escritório",
  "Conversas organizadas, com histórico sempre à mão",
];

const ILLUSTRATION = "/media/juszap/bot.svg";

const CheckoutShell = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <S.Overlay>
      <S.Card>
        <S.Left>
          <S.Illustration
            src={ILLUSTRATION}
            alt="IA Assistente para WhatsApp"
            onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
          />
          <S.BenefitList>
            {BENEFITS.map((benefit) => (
              <S.BenefitItem key={benefit}>
                <VerifiedOutlinedIcon sx={{ fontSize: 18, color: "#01AB7D !important" }} />
                <span>{benefit}</span>
              </S.BenefitItem>
            ))}
          </S.BenefitList>
        </S.Left>

        <S.Right>
          <S.CloseButton onClick={onClose} aria-label="Fechar">
            <CloseIcon sx={{ fontSize: 22 }} />
          </S.CloseButton>

          {children}
        </S.Right>
      </S.Card>
    </S.Overlay>
  );
};

export default CheckoutShell;
